/**
 * @generated SignedSource<<a426743b8e2cd0f1a892b83a5146685e>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import type { Fragment, ReaderFragment } from 'relay-runtime';
import type { FragmentRefs } from "relay-runtime";
export type plainText_nativeIssueTable_PlainTextCellOld_fieldRef$data = {
  readonly id?: string;
  readonly text: string | null | undefined;
  readonly " $fragmentType": "plainText_nativeIssueTable_PlainTextCellOld_fieldRef";
};
export type plainText_nativeIssueTable_PlainTextCellOld_fieldRef$key = {
  readonly " $data"?: plainText_nativeIssueTable_PlainTextCellOld_fieldRef$data;
  readonly " $fragmentSpreads": FragmentRefs<"plainText_nativeIssueTable_PlainTextCellOld_fieldRef">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [
    {
      "kind": "RootArgument",
      "name": "__relay_internal__pv__atlassianjirarelayprovidersrcissinglelineeventdelegatorenabledrelayprovider"
    }
  ],
  "kind": "Fragment",
  "name": "plainText_nativeIssueTable_PlainTextCellOld_fieldRef",
  "selections": [
    {
      "condition": "__relay_internal__pv__atlassianjirarelayprovidersrcissinglelineeventdelegatorenabledrelayprovider",
      "kind": "Condition",
      "passingValue": true,
      "selections": [
        {
          "kind": "ScalarField",
          "name": "id"
        }
      ]
    },
    {
      "kind": "ScalarField",
      "name": "text"
    }
  ],
  "type": "JiraSingleLineTextField"
};

(node as any).hash = "fac8b4989806cd588f8fc44360173e86";

export default node;
